export default __webpack_public_path__ + "static/media/pincident.37260cfc.png";